import * as React from 'react';
import { SVGProps } from 'react';

const LockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M38 16.6668H42.1667C42.7192 16.6668 43.2491 16.8863 43.6398 17.277C44.0305 17.6677 44.25 18.1976 44.25 18.7502V43.7502C44.25 44.3027 44.0305 44.8326 43.6398 45.2233C43.2491 45.614 42.7192 45.8335 42.1667 45.8335H8.83333C8.2808 45.8335 7.75089 45.614 7.36019 45.2233C6.96949 44.8326 6.75 44.3027 6.75 43.7502V18.7502C6.75 18.1976 6.96949 17.6677 7.36019 17.277C7.75089 16.8863 8.2808 16.6668 8.83333 16.6668H13V14.5835C13 11.2683 14.317 8.08887 16.6612 5.74466C19.0054 3.40046 22.1848 2.0835 25.5 2.0835C28.8152 2.0835 31.9946 3.40046 34.3388 5.74466C36.683 8.08887 38 11.2683 38 14.5835V16.6668ZM10.9167 20.8335V41.6668H40.0833V20.8335H10.9167ZM23.4167 29.1668H27.5833V33.3335H23.4167V29.1668ZM15.0833 29.1668H19.25V33.3335H15.0833V29.1668ZM31.75 29.1668H35.9167V33.3335H31.75V29.1668ZM33.8333 16.6668V14.5835C33.8333 12.3734 32.9554 10.2537 31.3926 8.69094C29.8298 7.12814 27.7101 6.25016 25.5 6.25016C23.2899 6.25016 21.1702 7.12814 19.6074 8.69094C18.0446 10.2537 17.1667 12.3734 17.1667 14.5835V16.6668H33.8333Z"
      fill="#E35854"
    />
  </svg>
);

export default LockIcon;
